import { InteractiveContainer } from "@jugl-web/ui-components/cross-platform";
import { useTranslations } from "@jugl-web/utils";
import { FC } from "react";
import { ReactComponent as ArrowLeftIcon } from "@web-src/images/icons/arrow-left.svg";
import { ReactComponent as JuglLogo } from "../assets/jugl-logo.svg";
import { ReactComponent as InfoIcon } from "../assets/info.svg";
import { ReactComponent as CXGradient } from "../assets/cx-gradient.svg";
import { ReactComponent as PMGradient } from "../assets/pm-gradient.svg";
import cxImage from "../assets/cx-image.png";
import pmImage from "../assets/pm-image.png";

export const SelectProductView: FC<{
  onBack: () => void;
  onSelectPM: () => void;
  onSelectCX: () => void;
}> = ({ onBack, onSelectPM, onSelectCX }) => {
  const { t } = useTranslations();

  return (
    <div className="font-secondary w-[440px] p-4">
      <div className="flex items-center gap-2 pb-4">
        <InteractiveContainer
          className="flex h-8 w-8 items-center justify-center rounded-lg"
          onClick={onBack}
        >
          <ArrowLeftIcon className="h-4 w-4" />
        </InteractiveContainer>
        <span className="text-dark font-secondary text-base font-medium">
          {t({
            id: "select-product.title",
            defaultMessage: "Select Product",
          })}
        </span>
      </div>
      <div className="flex flex-col gap-4">
        <InteractiveContainer
          className="bg-dark relative flex items-center overflow-hidden rounded-xl py-6 pl-4"
          onClick={onSelectCX}
        >
          <CXGradient className="pointer-events-none absolute left-[100px] top-1/2 -translate-y-1/2" />
          <div className="relative z-[1] flex w-[250px] shrink-0 flex-col gap-4">
            <div className="flex flex-col gap-[3px]">
              <JuglLogo className="h-[18px] w-[38px]" />
              <span className="font-secondary text-[15px] font-semibold text-white">
                {t({
                  id: "select-product.customer-experience",
                  defaultMessage: "Customer Experience",
                })}
              </span>
            </div>
            <span className="font-secondary text-dark-100 text-[13px] font-light leading-[1.4]">
              {t({
                id: "select-product.cx-description",
                defaultMessage:
                  "AI Agent driven tool for Sales and Customer Support",
              })}
            </span>
          </div>
          <img
            src={cxImage}
            alt=""
            className="pointer-events-none absolute right-0 top-1/2 h-[134px] -translate-y-1/2"
          />
        </InteractiveContainer>
        <InteractiveContainer
          className="relative flex items-center overflow-hidden rounded-xl py-6 pl-4"
          style={{ backgroundColor: "#1045A1" }}
          onClick={onSelectPM}
        >
          <PMGradient className="pointer-events-none absolute left-[100px] top-1/2 -translate-y-1/2" />
          <div className="relative z-[1] flex w-[250px] shrink-0 flex-col gap-4">
            <div className="flex flex-col gap-[3px]">
              <JuglLogo className="h-[18px] w-[38px]" />
              <span className="font-secondary text-[15px] font-semibold text-white">
                {t({
                  id: "select-product.project-management",
                  defaultMessage: "Project Management",
                })}
              </span>
            </div>
            <span className="font-secondary text-dark-100 text-[13px] font-light leading-[1.4]">
              {t({
                id: "select-product.pm-description",
                defaultMessage:
                  "AI driven tool for Project and Team management",
              })}
            </span>
          </div>
          <img
            src={pmImage}
            alt=""
            className="pointer-events-none absolute right-0 top-1/2 h-[134px] -translate-y-1/2"
          />
        </InteractiveContainer>
        <div className="bg-grey-100 flex items-center gap-3 rounded-xl p-3">
          <InfoIcon className="h-6 w-6 shrink-0" />
          <span className="font-secondary text-dark text-sm">
            {t(
              {
                id: "select-product.info-bar",
                defaultMessage: "Visit {link} to know more about Jugl Products",
              },
              {
                link: (
                  <a
                    href="https://jugl.com"
                    target="_blank"
                    rel="noreferrer"
                    className="text-primary-800 underline"
                  >
                    jugl.com
                  </a>
                ),
              }
            )}
          </span>
        </div>
      </div>
    </div>
  );
};
